import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import AdminLogin from "./pages/AdminLogin";
import RegisterStep1 from "./pages/RegisterStep1";
import RegisterKYC from "./pages/RegisterKYC";
import Dashboard from "./pages/DynamicDashboard";
import Wallet from "./pages/Wallet";
import Team from "./pages/Team";
import AdminDashboard from "./pages/AdminDashboard";
import PrivateRoute from "./components/PrivateRoute";
import BuyShare from "./pages/BuyShare";
import BuyProduct from "./pages/BuyProduct";
import Products from "./pages/Products";
import Home from "./pages/Home";
import Header from "./pages/Header";
import Features from "./pages/Features";
import About from "./pages/About";
import BusinessPlan from "./pages/BusinessPlan";
import Footer from "./pages/Footer";
import Contact from "./pages/Contact";
import LevelIncomeReport from "./pages/LevelIncomeReport";
import UserProfilePage from "./pages/UserProfilePage";
import TermsConditions from "./pages/TermsConditions";
import RoyaltyHistory from "./pages/RoyaltyHistory";
import ForgotPassword from "./pages/ForgotPassword";
import MobileStoreDashboard from "./pages/MobileStoreDashboard";
import { useContext, useEffect } from "react";
import ProductHome from "./components/ProductHome";
import CategoryProducts from "./pages/CategoryProducts";
import UserViewPage from "./pages/UserViewPage";
import { CartProvider } from "./context/CartContext";
import { AuthContext } from "./context/AuthContext";

function MobileStoreModeRoute() {
  const { user } = useContext(AuthContext);
  const mode = localStorage.getItem("dashboardMode");

  if (!user) return <Navigate to="/login" replace />;
  if (!user.isMobileStore || mode !== "mobile-store") {
    return <Navigate to="/dashboard" replace />;
  }

  return <MobileStoreDashboard />;
}

function LayoutWrapper() {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Hide header/footer on standalone dashboard pages
  const hideHeader =
    location.pathname?.startsWith("/dashboard") ||
    location.pathname?.startsWith("/register") ||
    location.pathname?.startsWith("/admin") ||
    location.pathname?.startsWith("/admin-login") ||
    location.pathname?.startsWith("/user-view") ||
    location.pathname?.startsWith("/mobile-store-dashboard");

  return (
    <>
      {!hideHeader && <Header />}

      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/register" element={<RegisterStep1 />} />
        <Route path="/register-kyc" element={<RegisterKYC />} />
        <Route path="/features" element={<Features />} />
        <Route path="/about" element={<About />} />
        <Route path="/business-plan" element={<BusinessPlan />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/products" element={<ProductHome />} />
        <Route path="/category/:categoryId" element={<CategoryProducts />} />
        <Route path="/terms-and-conditions" element={<TermsConditions />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={<Dashboard />}
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <UserProfilePage />
            </PrivateRoute>
          }
        />

        <Route
          path="/wallet"
          element={
            <PrivateRoute>
              <Wallet />
            </PrivateRoute>
          }
        />

        <Route
          path="/team"
          element={
            <PrivateRoute>
              <Team />
            </PrivateRoute>
          }
        />

        <Route
          path="/buy-share"
          element={
            <PrivateRoute>
              <BuyShare />
            </PrivateRoute>
          }
        />

        <Route
          path="/buy-product"
          element={
            <PrivateRoute>
              <BuyProduct />
            </PrivateRoute>
          }
        />

        <Route
          path="/products"
          element={
            <PrivateRoute>
              <Products />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <AdminDashboard />
            </PrivateRoute>
          }
        />

        <Route
          path="/user-view"
          element={
            <PrivateRoute>
              <UserViewPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/level-income"
          element={
            <PrivateRoute>
              <LevelIncomeReport />
            </PrivateRoute>
          }
        />

        <Route
          path="/royalty-history"
          element={
            <PrivateRoute>
              <RoyaltyHistory />
            </PrivateRoute>
          }
        />

        <Route
          path="/mobile-store-dashboard"
          element={<MobileStoreModeRoute />}
        />

      </Routes>
      {!hideHeader && <Footer />}
    </>
  );
}

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <LayoutWrapper />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
